import React, { useEffect, useState } from 'react';
import { Typography, useTheme, Stack } from '@mui/material';
import { CancelToken } from 'apisauce';
import DatepickerStatic from '../../../../components/DatePickerStatic';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import GraphComp from '../../../../components/Graphs/GraphComp';
import SquareIcon from '@mui/icons-material/Square';
import appapi from '../../../../api/apiClient';
import moment from 'moment';
import { styled } from '@mui/material/styles';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import ActivityIndicator from '../../../../components/DataTable/ActivityIndicator';
import { useTranslation } from 'react-i18next';

const LightTooltip = styled(({ className, ...props }) => (
  <Tooltip
    {...props}
    classes={{ popper: className }}
    placement="bottom-end"
  />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.white,
    color: 'rgba(0, 0, 0, 0.87)',
    maxwidth: '200px',
    boxShadow: theme.shadows[1],
    fontSize: 11,
  },
}));
export default function GraphDetails({ data, voyageDetails }) {
  const { t } = useTranslation();
  const theme = useTheme();
  let source = CancelToken.source();
  let source2 = CancelToken.source();
  const [loading, setLoading] = useState(false);
  const [doubleVoyageGrpahData, setDoubleVoyageGrpahData] = useState([]);
  const [singleVoyageGrpahData, setsingleVoyageGrpahData] = useState([]);
  useEffect(() => {
    if (data) {
      initApi();
    }
    return () => {
      if (source) {
        source.cancel();
      }
      if (source2) {
        source2.cancel();
      }
    };
  }, [data]);
  const initApi = async () => {
    setLoading(true);
    await getsingleGraphDetails();
    await getdoubleGraphDetails();
    setLoading(false);
  };
  const getdoubleGraphDetails = async (date) => {
    // setLoading(true)
    let month = date ? moment(new Date(date)).format('MM') : moment(new Date(voyageDetails?.fromDate)).format('MM');
    let year = date ? moment(new Date(date)).format('YYYY') : moment(new Date(voyageDetails?.fromDate)).format('YYYY');
    source.cancel();
    source = CancelToken.source();
    const response = await appapi.get(
      `/fleet/graphForEUAvsCperPEUA/${data?._id}`,
      {
        month: month,
        year: year,
      },
      {
        cancelToken: source.token,
      },
    );
    if (response.ok) {
      const data = response.data;
      if (data.status === '7400') {
        const convertedData = data?.response?.map((item) => {
          const convertedDate = moment(new Date(item?.reportDate)).format('DD');
          return { name: convertedDate, EUA: item.estimatedEua, EUACP: item?.cperP };
        });
        setDoubleVoyageGrpahData([]);
        setDoubleVoyageGrpahData(convertedData);
        // setLoading(false)
      }
    }
  };
  const getsingleGraphDetails = async (date) => {
    // setLoading(true)
    let month = date ? moment(new Date(date)).format('MM') : moment(new Date(voyageDetails?.fromDate)).format('MM');
    let year = date ? moment(new Date(date)).format('YYYY') : moment(new Date(voyageDetails?.fromDate)).format('YYYY');
    source2.cancel();
    source2 = CancelToken.source();
    const response = await appapi.get(
      `/fleet/graphForEUA/${data?._id}`,
      {
        month: month,
        year: year,
      },
      {
        cancelToken: source2.token,
      },
    );
    if (response.ok) {
      const data = response.data;
      if (data.status === '7400') {
        const convertedData = data?.response?.map((item) => {
          const convertedDate = moment(new Date(item?.reportDate)).format('DD');
          return { name: convertedDate, EUA: item.estimatedEua };
        });
        setsingleVoyageGrpahData([]);
        setsingleVoyageGrpahData(convertedData);
        // setLoading(false)
      }
    }
  };

  return (
    <>
      {' '}
      {loading && (
        <Stack
          flex={1}
          alignItems={'center'}
          justifyContent={'center'}
        >
          <ActivityIndicator />
        </Stack>
      )}
      {!loading && (
        <Stack className="flex-overflow">
          <Stack style={{ marginTop: '10px' }}>
            <Stack
              direction="row"
              style={{ margin: '10px', justifyContent: 'space-between', alignItems: 'center' }}
            >
              <Typography style={{ fontSize: '14px', marginLeft: '15px', color: '#14285A', fontWeight: '600' }}>{t('Estimated EUA')}</Typography>
              <Stack
                direction="row"
                className="flex !justify-center !items-center !text-[#14285A40]"
              >
                <DatepickerStatic
                  voyageDetails={voyageDetails}
                  dateData={(date) => {
                    getsingleGraphDetails(date);
                  }}
                />
                <LightTooltip title={t('Basic')}>
                  <HelpOutlineIcon className="!ml-[5px] !w-[17px] !h-[17px]" />
                </LightTooltip>
              </Stack>
            </Stack>
            <Stack position="relative">
              <GraphComp graphData={singleVoyageGrpahData} />
            </Stack>
          </Stack>
          <Stack style={{ marginTop: '10px' }}>
            <Stack
              direction="row"
              style={{ margin: '10px', justifyContent: 'space-between', alignItems: 'center' }}
            >
              <Typography style={{ fontSize: '14px', marginLeft: '15px', color: '#14285A', fontWeight: '600' }}>{t('Estimated EUA vs EUA C/P')}</Typography>
              <Stack
                direction="row"
                className="flex !justify-center !items-center !text-[#14285A40]"
              >
                <DatepickerStatic
                  dateData={(date) => {
                    getdoubleGraphDetails(date);
                  }}
                  voyageDetails={voyageDetails}
                />
                <LightTooltip title={t('Show the comparison of how much is being used vs what was predicted by C/P')}>
                  <HelpOutlineIcon className="!ml-[5px] !w-[17px] !h-[17px]" />
                </LightTooltip>
              </Stack>
            </Stack>
            {doubleVoyageGrpahData?.length > 0 && (
              <Stack
                direction="row"
                className="!pl-[70%] !pt-[10px] !bg-[#e7ebf4] "
                // alignSelf={'flex-end'}
              >
                <Stack direction="row">
                  <SquareIcon className="!text-[18px] !text-[#FFCC00]" />
                  <Typography className="!text-[12px] !text-[#003399]">EUA</Typography>
                </Stack>
                <Stack
                  direction="row"
                  className="!ml-[20px]"
                >
                  <SquareIcon className="!text-[18px] !text-[#003399]" />
                  <Typography className="!text-[12px] !text-[#003399]">EUA C/P</Typography>
                </Stack>
                
              </Stack>
            )}
            <Stack position="relative">
              <GraphComp
                graphData={doubleVoyageGrpahData}
                doubleGraph={true}
              />
            </Stack>
          </Stack>
        </Stack>
      )}
    </>
  );
}
